define((require) => {
    "use strict";

    const Backbone = require("backbone");

    // "MANUAL" is the user created tag type.
    // "ZMAGS_GROUP_ID" is generated by inventory.
    // Anything else is generated by Amazon Rekognition
    const Types = {
        MANUAL: "MANUAL",
        ZMAGS_GROUP_ID: "ZMAGS_GROUP_ID"
    };

    return Backbone.Model.extend({

        defaults: {
            name: "",
            /**
             * how confident this tag is relevant
             * @type number
             */
            confidence: 100,
            type: Types.MANUAL
        },

        /**
         *
         * @param {number} truncateLength example. 30 for first 30 chars
         * @returns {string[]} array of truncated tag names
         */
        toTruncatedTagName(truncateLength) {
            const tagName = this.get("name");
            if (tagName.length > truncateLength) {
                return tagName.substring(0, truncateLength) + "\u2026"; // \u2026 = "..."
            }
            return tagName;
        }
    }, {
        Types
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/assets/image/tags/ImageTagModel.js